"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  toChainId: true,
  addChain: true,
  getChain: true,
  chainList: true,
  addressEqual: true,
  chainEqual: true
};
exports.addChain = addChain;
exports.addressEqual = addressEqual;
exports.chainEqual = chainEqual;
exports.chainList = chainList;
exports.getChain = getChain;
exports.toChainId = toChainId;
var _bignumber = require("@ethersproject/bignumber");
var _EthNetwork = require("./EthNetwork");
Object.keys(_EthNetwork).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _EthNetwork[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _EthNetwork[key];
    }
  });
});
const unknownNetwork = new _EthNetwork.EthNetwork({
  chainId: 0,
  aliases: [],
  networkName: "Unknown Network"
});
const rawNetworks = [new _EthNetwork.EthNetwork({
  chainId: 1,
  networkName: "Mainnet",
  aliases: ["mainnet", "main", "eth"],
  nodeUrl: new _EthNetwork.InfuraNode(null, "25c0a8904f7c460086f8afb839e102d5"),
  explorer: "https://etherscan.io",
  description: "The Main Ethereum Network",
  eip1559: true,
  priorityFee: "4000000000"
}), new _EthNetwork.EthNetwork({
  chainId: 4,
  networkName: "Rinkeby",
  aliases: ["rinkeby", "rin"],
  nodeUrl: "https://rinkeby.blockwell.ai/geth/http",
  ws: "wss://rinkeby.blockwell.ai/geth/ws",
  explorer: "https://rinkeby.etherscan.io",
  description: "Rinkeby Test Network",
  eip1559: true,
  priorityFee: "1000000000"
}), new _EthNetwork.EthNetwork({
  chainId: 5,
  networkName: "Goerli",
  aliases: ["goerli", "görli", "gorli", "gor"],
  nodeUrl: new _EthNetwork.InfuraNode("goerli", "25c0a8904f7c460086f8afb839e102d5"),
  explorer: "https://goerli.etherscan.io",
  description: "Goerli Test Network",
  eip1559: true,
  priorityFee: "1000000000"
}), new _EthNetwork.EthNetwork({
  chainId: 24,
  networkName: "KardiaChain",
  aliases: ["kardia", "kardiachain"],
  nodeUrl: "https://rpc.kardiachain.io",
  explorer: "https://explorer.kardiachain.io/",
  gasPrice: "2000000000",
  symbol: "KAI"
}), new _EthNetwork.EthNetwork({
  chainId: 42,
  networkName: "Kovan",
  aliases: ["kovan", "kov"],
  explorer: "https://kovan.etherscan.io",
  description: "Kova Test Network",
  gasPrice: "20000000000"
}), new _EthNetwork.BlockscoutNetwork({
  chainId: 49111,
  networkName: "Firechain",
  aliases: ["firechain", "fire"],
  nodeUrl: "https://node.firechain.blockwell.ai",
  ws: "wss://ws.node.firechain.blockwell.ai",
  explorer: "https://explorer.firechain.blockwell.ai",
  description: "Blockwell's sidechain",
  gasPrice: "0"
}), new _EthNetwork.BlockscoutNetwork({
  chainId: 49112,
  networkName: "Defactor Chain",
  aliases: ["defactor"],
  nodeUrl: "https://node.defactor.com",
  ws: "wss://ws.node.defactor.com",
  explorer: "https://explorer.defactor.com",
  description: "Defactor's Blockchain",
  gasPrice: "0"
}), new _EthNetwork.BlockscoutNetwork({
  chainId: 49113,
  networkName: "Stripchain",
  aliases: ["stripchain", "strip"],
  nodeUrl: "https://node.stripchain.blockwell.ai",
  ws: "wss://ws.node.stripchain.blockwell.ai",
  explorer: "https://explorer.stripchain.blockwell.ai",
  description: "Stripchain",
  gasPrice: "0"
}), new _EthNetwork.BlockscoutNetwork({
  chainId: 49777,
  networkName: "Leprichain",
  aliases: ["leprichain", "lepricon", "lep"],
  nodeUrl: "https://node.leprichain.blockwell.ai",
  ws: "wss://ws.node.leprichain.blockwell.ai",
  explorer: "https://explorer.leprichain.blockwell.ai",
  description: "Lepricon's Blockchain",
  gasPrice: "0"
}), new _EthNetwork.BlockscoutNetwork({
  chainId: 49778,
  networkName: "LepriTEST",
  aliases: ["lepritest"],
  explorer: "https://explorer.lepritest.blockwell.ai",
  description: "Leprichain Test Chain",
  gasPrice: "0"
}), new _EthNetwork.EthNetwork({
  chainId: 56,
  networkName: "Binance Smart Chain",
  aliases: ["bsc", "binance"],
  nodeUrl: "https://bsc-dataseed.binance.org",
  explorer: "https://bscscan.com",
  symbol: "BNB",
  description: "Ethereum-compatible Binance Smart Chain",
  gasPrice: "6000000000"
}), new _EthNetwork.EthNetwork({
  chainId: 97,
  networkName: "Binance Testchain",
  aliases: ["prebsc", "bsc-testnet"],
  nodeUrl: "https://data-seed-prebsc-2-s3.binance.org:8545",
  explorer: "https://testnet.bscscan.com",
  symbol: "BNB",
  description: "Binance Smart Chain Test Network",
  gasPrice: "10000000000"
}), new _EthNetwork.EthNetwork({
  chainId: 43114,
  networkName: "Avalanche C-Chain",
  aliases: ["avalanche"],
  nodeUrl: "https://speedy-nodes-nyc.moralis.io/1d05acf4cafa210a427c0cfa/avalanche/mainnet",
  explorer: "https://snowtrace.io",
  symbol: "AVAX",
  description: "Avalanche C-Chain",
  eip1559: true,
  priorityFee: "1000000000"
})];
const networks = rawNetworks.map(it => Object.freeze(it));
/**
 * Parses the input into an Ethereum chain ID.
 */
function toChainId(input) {
  if (input === undefined || input === null) {
    return 0;
  }
  if (input instanceof _EthNetwork.EthNetwork) {
    return input.chainId;
  }
  if (typeof input === "number") {
    return input;
  }
  if (typeof input === "string") {
    if (Number.isInteger(parseInt(input))) {
      return parseInt(input);
    }
    if (input.startsWith && input.startsWith("0x")) {
      return _bignumber.BigNumber.from(input).toNumber();
    }
    let alias = input.toLowerCase();
    for (let net of Object.values(networks)) {
      if (net.aliases.includes(alias)) {
        return net.chainId;
      }
    }
    return 0;
  }
  if ("chainId" in input) {
    return getChain(input.chainId).chainId;
  }
  if ("network" in input) {
    return getChain(input.network).chainId;
  }
  return 0;
}
function addChain(config) {
  let network = new _EthNetwork.EthNetwork(config);
  networks.push(Object.freeze(network));
  return network;
}

/**
 * Parses the input into an Ethereum network and returns information on it.
 */
function getChain(network) {
  let chainId = toChainId(network);
  let net = networks.find(it => it.chainId === chainId);
  if (net) {
    return net;
  } else {
    return unknownNetwork;
  }
}

/**
 * List all supported networks.
 */
function chainList() {
  return networks;
}
function addressEqual(a, b) {
  if (!a || !b) {
    return false;
  }
  return a.toLowerCase() === b.toLowerCase();
}
function chainEqual(a, b) {
  if (!a || !b) {
    return false;
  }
  let aId = toChainId(a);
  let bId = toChainId(b);
  if (!aId || !bId) {
    return false;
  }
  return aId === bId;
}
//# sourceMappingURL=index.js.map